// Inhoud van de V3-homepage. Alleen feitelijke, controleerbare uitspraken.
export const QUOTE_PATH = "/offerte-aanvragen";
export const quoteHref = (onderwerp, params = {}) => {
  const q = new URLSearchParams(Object.entries({ onderwerp, ...params }).filter(([, v]) => v)).toString();
  return q ? `${QUOTE_PATH}?${q}` : QUOTE_PATH;
};

export const SERVICE_SCOPE = ["Demontage", "Levering", "HR++ / HR+++ glas", "Montage", "Afwerking"];

export const TRUST_POINTS = [
  "Actief in heel Zuid-Holland",
  "Demontage, levering en montage",
  "HR++ en HR+++ glas mogelijk",
  "Nette afwerking binnen en buiten",
  "Gratis inmeten",
];

export const PRODUCTS = [
  { id: "kunststof-kozijnen", media: "product_kunststof_kozijnen", material: "Kunststof", title: "Kunststof kozijnen",
    href: "/kunststof-kozijnen", onderwerp: "kunststof-kozijnen",
    text: "Onderhoudsarm, goed isolerend en verkrijgbaar in vele kleuren en houtnerfstructuren.",
    specs: ["Gealan-profielen", "HR++ / HR+++", "Kleur naar keuze"] },
  { id: "aluminium-kozijnen", media: "product_aluminium_kozijnen", material: "Aluminium", title: "Aluminium kozijnen",
    href: "/aluminium-kozijnen", onderwerp: "aluminium-kozijnen",
    text: "Slanke profielen en grote glasvlakken voor een strakke, moderne uitstraling.",
    specs: ["Smalle aanzichten", "Thermisch onderbroken", "Poedercoating"] },
  { id: "kunststof-schuifpui", media: "product_kunststof_schuifpui", material: "Kunststof", title: "Kunststof schuifpuien",
    href: "/kunststof-schuifpui", onderwerp: "kunststof-schuifpui",
    text: "Meer licht en een open verbinding met de tuin, met een prijsbewust en onderhoudsarm profiel.",
    specs: ["Schuif- of hefschuifpui", "Veiligheidsglas", "Lage dorpel mogelijk"] },
  { id: "aluminium-schuifpui", media: "product_aluminium_schuifpui", material: "Aluminium", title: "Aluminium (hef)schuifpuien",
    href: "/aluminium-schuifpui", onderwerp: "aluminium-hefschuifpui",
    text: "Voor brede openingen: minimale profielen en een lichte bediening, ook bij grote panelen.",
    specs: ["Grote breedtes", "Licht bedienbaar", "Strak design"] },
  { id: "deuren", media: "product_deuren", material: "Kunststof & aluminium", title: "Voordeuren en achterdeuren",
    href: "/deuren", onderwerp: "deuren",
    text: "Veilige, goed isolerende deuren met meerpuntsluiting — van klassiek tot modern.",
    specs: ["Meerpuntsluiting", "Inbraakwerend beslag", "Zijlicht mogelijk"] },
];

export const QUICK_START = [
  { label: "Kunststof kozijnen", onderwerp: "kunststof-kozijnen", icon: "Grid2x2" },
  { label: "Aluminium kozijnen", onderwerp: "aluminium-kozijnen", icon: "Columns2" },
  { label: "Kunststof schuifpui", onderwerp: "kunststof-schuifpui", icon: "PanelLeft" },
  { label: "Aluminium (hef)schuifpui", onderwerp: "aluminium-hefschuifpui", icon: "PanelsTopLeft" },
  { label: "Kunststof deur", onderwerp: "kunststof-deuren", icon: "DoorOpen" },
  { label: "Aluminium deur", onderwerp: "aluminium-deuren", icon: "DoorClosed" },
  { label: "Ik weet het nog niet", onderwerp: "weet-niet", icon: "MessageCircle", wide: true },
];

export const WHY_POINTS = [
  { icon: "Handshake", title: "Alles uit één hand", text: "Advies, inmeten, demontage van de oude kozijnen, levering, montage en afwerking via één vast aanspreekpunt." },
  { icon: "Wrench", title: "Ervaren monteurs", text: "Montage door ervaren zelfstandige vakmensen, met een hoofdmonteur die ruim 20 jaar praktijkervaring heeft in kozijnmontage." },
  { icon: "Layers", title: "Kwalitatieve systemen", text: "Duitse GEALAN-profielen voor kunststof kozijnen. Aluminium systemen stemmen we af op uw opening en wensen." },
  { icon: "Thermometer", title: "Goed geïsoleerd", text: "Nieuwe kozijnen met HR++ glas; HR+++ (triple) glas is mogelijk wanneer profiel en situatie het toelaten." },
  { icon: "MapPin", title: "Regionaal en persoonlijk", text: "Een partij uit Maassluis die de woningen in de regio kent en direct bereikbaar is." },
  { icon: "ClipboardCheck", title: "Heldere offerte", text: "Eerst een vrijblijvende prijsindicatie, daarna een offerte met duidelijk omschreven werkzaamheden." },
];

export const GLASS_ROWS = [
  ["Opbouw", "Dubbel glas met coating en edelgasvulling", "Drie glasbladen met twee spouwen"],
  ["Isolatiewaarde (Ug, indicatief)", "ca. 1,0 – 1,1 W/m²K", "ca. 0,5 – 0,7 W/m²K"],
  ["Gewicht", "Standaard", "Zwaarder; profiel en beslag moeten erop berekend zijn"],
  ["Vaak gekozen bij", "Vervanging in bestaande woningen", "Hoge isolatie-eisen of een (bijna) energieneutrale woning"],
  ["Geluidwerend", "Mogelijk met aangepaste glasopbouw", "Mogelijk met aangepaste glasopbouw"],
  ["Prijs", "Standaard bij nieuwe kozijnen", "Meerprijs ten opzichte van HR++"],
];

export const INSPIRATION = [
  { media: "inspiration_1", title: "Karakteristiek wonen", text: "Kunststof kozijnen met roedes en een klassieke kleur passen goed bij jaren-30 woningen.", href: "/kunststof-kozijnen", cta: "Kunststof kozijnen" },
  { media: "inspiration_2", title: "Licht in de aanbouw", text: "Een aluminium glazen pui maakt van een aanbouw een lichte leefruimte.", href: "/aluminium-schuifpui", cta: "Aluminium schuifpuien" },
  { media: "inspiration_3", title: "De hele woning in één keer", text: "Alle kozijnen en deuren tegelijk vervangen geeft één uitstraling en één planning.", href: "/kunststof-kozijnen", cta: "Kozijnen vervangen" },
];

